// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V22H11V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 22H22V13H13V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 11V2H13V11H22Z"}}]};

const ModuleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'module-filled',
    ref,
    icon: element,
  },
));

ModuleFilledIcon.displayName = 'ModuleFilledIcon';

export default ModuleFilledIcon;
